import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicSupportRequestCreateParamsRawI,
	LWApiPublicSupportRequestCreateResultRawI,
} from '@liquidweb-dev/club-sauce/public/support/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { SUPPORT_REQUEST_LIST_QUERY_KEY } from './useList';

const useSupportRequestCreate = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicSupportRequestCreateResultRawI,
		ApiErrorI,
		LWApiPublicSupportRequestCreateParamsRawI
	>({
		mutationFn: (params) => api.support.request.apiRaw.create(params),
		onSuccess: (data, params) => {
			const ccList = params?.cc_list || [];

			if (typeof ccList === 'string') {
				return;
			}

			ccList.forEach((email) => {
				if (!data?.cc_list?.includes(email)) {
					toast.danger(
						`We were unable to save ${email} to the cc email list. Did you enter in a valid email?`,
					);
				}
			});

			queryClient.invalidateQueries({
				queryKey: [SUPPORT_REQUEST_LIST_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useSupportRequestCreate;
